import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/containers/specifics/vendors/settings/Page";

export const PATH = "/vendors/settings";

function Home() {
	return (
		<>
			<NskHead title="設定" />
			<Component />
		</>
	);
}

export default Home;
